var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.showSelvaggiaCannotRaise ||
    _vm.canSelvaggiaAct ||
    _vm.showSelvaggiaPassoHint ||
    _vm.showSelvaggiaWaiting
    ? _c(
        "div",
        { staticClass: "panoramica-actions" },
        [
          _vm.showSelvaggiaCannotRaise
            ? _c("div", { staticClass: "panoramica-selvaggia-hint" }, [
                _vm._v("\n    Non puoi alzare ulteriormente l'offerta\n  "),
              ])
            : _vm.canSelvaggiaAct
            ? [
                _vm.migliore_offerta.offerta && !_vm.offertaToConfirm
                  ? _vm._l(_vm.rilanciRelativi, function (incremento) {
                      return _c(
                        "v-btn",
                        {
                          key: incremento,
                          attrs: {
                            rounded: "",
                            color: "primary",
                            disabled: !_vm.canRilanciareDi(incremento),
                          },
                          on: {
                            click: function ($event) {
                              return _vm.preparaRilancio(incremento)
                            },
                          },
                        },
                        [
                          _vm._v(
                            "\n        +" + _vm._s(incremento) + "\n      "
                          ),
                        ]
                      )
                    })
                  : _vm.offertaToConfirm
                  ? _c(
                      "v-btn",
                      {
                        staticClass: "pr-1",
                        attrs: { rounded: "", color: "primary" },
                        on: { click: _vm.confirmOfferta },
                      },
                      [
                        _vm._v("\n      Confermo\n      "),
                        _c("crediti", {
                          staticClass: "ml-2",
                          attrs: {
                            crediti: _vm.offertaToConfirm,
                            variant: "dark",
                          },
                        }),
                        _vm._v(" "),
                        _c(
                          "v-menu",
                          {
                            attrs: { "offset-y": "", left: "" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "activator",
                                  fn: function (ref) {
                                    var on = ref.on
                                    var attrs = ref.attrs
                                    return [
                                      _c(
                                        "v-btn",
                                        _vm._g(
                                          _vm._b(
                                            {
                                              staticClass: "ml-1 white--text",
                                              attrs: {
                                                icon: "",
                                                "x-small": "",
                                              },
                                              on: {
                                                click: function ($event) {
                                                  $event.stopPropagation()
                                                },
                                              },
                                            },
                                            "v-btn",
                                            attrs,
                                            false
                                          ),
                                          on
                                        ),
                                        [
                                          _c(
                                            "v-icon",
                                            { attrs: { small: "" } },
                                            [_vm._v("expand_more")]
                                          ),
                                        ],
                                        1
                                      ),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              303347142
                            ),
                          },
                          [
                            _vm._v(" "),
                            _c(
                              "v-list",
                              {
                                staticClass: "selvaggia-confirm-menu",
                                attrs: { dense: "" },
                              },
                              [
                                _c(
                                  "v-list-item",
                                  {
                                    on: { click: _vm.annullaOffertaToConfirm },
                                  },
                                  [
                                    _c(
                                      "v-list-item-icon",
                                      { staticClass: "mr-2" },
                                      [
                                        _c(
                                          "v-icon",
                                          {
                                            attrs: { small: "", color: "navy" },
                                          },
                                          [_vm._v("close")]
                                        ),
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "v-list-item-title",
                                      {
                                        staticClass:
                                          "navy--text text--darken-2 font-weight-bold pr-4",
                                      },
                                      [
                                        _vm._v(
                                          "\n              Annulla offerta\n            "
                                        ),
                                      ]
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "v-btn",
                  {
                    attrs: { rounded: "", color: "primary" },
                    on: { click: _vm.showNumpad },
                  },
                  [_vm._v("\n      Offerta\n    ")]
                ),
                _vm._v(" "),
                _c(
                  "v-btn",
                  {
                    staticClass: "text--text",
                    attrs: {
                      rounded: "",
                      color: "white",
                      disabled: _vm.vincitore === _vm.user_uid,
                    },
                    on: {
                      click: function ($event) {
                        return _vm.setPasso(true)
                      },
                    },
                  },
                  [_vm._v("\n      Passo\n    ")]
                ),
              ]
            : _vm.showSelvaggiaPassoHint
            ? _c("div", { staticClass: "panoramica-selvaggia-hint" }, [
                _vm._v("\n    " + _vm._s(_vm.selvaggiaPassoText) + "\n  "),
              ])
            : _vm.showSelvaggiaWaiting
            ? _c("div", { staticClass: "panoramica-selvaggia-hint" }, [
                _vm._v("\n    In attesa degli altri partecipanti...\n  "),
              ])
            : _vm._e(),
        ],
        2
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }